import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Users, Target, Globe, Mail } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50/50 to-white">
      {/* Header */}
      <header className="bg-white border-b border-blue-100 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors w-fit">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">トップページに戻る</span>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-blue-600 rounded-lg">
              <Users className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">運営者情報</h1>
          </div>
        </div>

        <div className="space-y-6">
          <Card className="border border-gray-100 shadow-sm">
            <CardHeader>
              <CardTitle className="text-lg text-gray-800 flex items-center gap-2">
                <Globe className="w-5 h-5 text-blue-600" />
                サイト情報
              </CardTitle>
            </CardHeader>
            <CardContent>
              <dl className="space-y-4">
                <div className="flex flex-col sm:flex-row sm:gap-4">
                  <dt className="font-medium text-gray-700 sm:w-32 flex-shrink-0">サイト名</dt>
                  <dd className="text-gray-600">アルバイト年収の壁シミュレーター</dd>
                </div>
                <div className="flex flex-col sm:flex-row sm:gap-4">
                  <dt className="font-medium text-gray-700 sm:w-32 flex-shrink-0">URL</dt>
                  <dd className="text-gray-600 break-all">https://103man-calculator.netlify.app</dd>
                </div>
              </dl>
            </CardContent>
          </Card>

          <Card className="border border-gray-100 shadow-sm">
            <CardHeader>
              <CardTitle className="text-lg text-gray-800 flex items-center gap-2">
                <Users className="w-5 h-5 text-blue-600" />
                運営者について
              </CardTitle>
            </CardHeader>
            <CardContent>
              <dl className="space-y-4">
                <div className="flex flex-col sm:flex-row sm:gap-4">
                  <dt className="font-medium text-gray-700 sm:w-32 flex-shrink-0">運営者名</dt>
                  <dd className="text-gray-600">Silent Code 開発チーム</dd>
                </div>
              </dl>
            </CardContent>
          </Card>

          <Card className="border border-gray-100 shadow-sm">
            <CardHeader>
              <CardTitle className="text-lg text-gray-800 flex items-center gap-2">
                <Target className="w-5 h-5 text-blue-600" />
                ミッション
              </CardTitle>
            </CardHeader>
            <CardContent className="text-gray-600 leading-relaxed">
              <p className="text-lg font-medium text-gray-700 mb-4">
                「日常の問題を解決する、シンプルで自動化されたツールを提供する」
              </p>
              <p>
                私たちSilent Code開発チームは、複雑な計算や面倒な作業を誰でも簡単に行えるツールを開発しています。テクノロジーの力で、皆様の日常をより便利に、より快適にすることを目指しています。
              </p>
            </CardContent>
          </Card>

          <Card className="border border-gray-100 shadow-sm">
            <CardHeader>
              <CardTitle className="text-lg text-gray-800 flex items-center gap-2">
                <Mail className="w-5 h-5 text-blue-600" />
                お問い合わせ
              </CardTitle>
            </CardHeader>
            <CardContent className="text-gray-600 leading-relaxed">
              <p>
                当サイトへのご質問、ご意見、ご要望などがございましたら、
                <Link to="/contact" className="text-blue-600 hover:underline font-medium">お問い合わせフォーム</Link>
                をご利用ください。
              </p>
              <p className="mt-4 text-sm text-gray-500">
                ※ お問い合わせへの返信には、数日いただく場合がございます。あらかじめご了承ください。
              </p>
            </CardContent>
          </Card>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

const Footer = () => (
  <footer className="bg-gray-50 border-t border-gray-200 mt-12">
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-sm text-gray-500">© 2026 Silent Code.</p>
        <nav className="flex items-center gap-6">
          <Link to="/privacy" className="text-sm text-gray-500 hover:text-blue-600 transition-colors">プライバシーポリシー</Link>
          <Link to="/about" className="text-sm text-gray-500 hover:text-blue-600 transition-colors">運営者情報</Link>
          <Link to="/contact" className="text-sm text-gray-500 hover:text-blue-600 transition-colors">お問い合わせ</Link>
        </nav>
      </div>
    </div>
  </footer>
);

export default AboutPage;
